import apiCall from "./apiCall";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async createSupplier(data) {
    let response = await apiCall("supplier/create", data);
    return response;
  },
  async fetchSuppliersList(data) {
    let response = await apiCall("supplier/list", data);
    return response;
  },
  async fetchSuppliersDetails(data) {
    let response = await apiCall("supplier/get_supplier_details", data);
    return response;
  },
  async updateSupplier(data) {
    let response = await apiCall("supplier/update_supplier_details", data);
    return response;
  },
  async fetchSuppliersListMini_data(data) {
    let response = await apiCall("supplier/list_suppliers_mini_data", data);
    return response;
  },
  async getSuppliersCount(data) {
    let response = await apiCall("supplier/count", data);
    return response;
  },
};
